import { render } from "./Index.vue?vue&type=template&id=5154cd2b&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=5154cd2b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5154cd2b"

export default script